export const DIETARY_FIT = 'dietary_fit';
export const OFFER_TYPE = 'offer_type';
export const CUISINE_TYPE = 'cuisine_type';
export const BUSINESS_TYPE = 'business_type';